require('./footer.styl');

// React
import React, { Component } from 'react';

// Semantic UI
import 'ta-semantic-ui/semantic/dist/components/button.css'
import 'ta-semantic-ui/semantic/dist/components/segment.css'
import 'ta-semantic-ui/semantic/dist/components/divider.css'
import 'ta-semantic-ui/semantic/dist/components/container.css'
import 'ta-semantic-ui/semantic/dist/components/message.css'
import 'ta-semantic-ui/semantic/dist/components/grid.css'
import 'ta-semantic-ui/semantic/dist/components/header.css'
import 'ta-semantic-ui/semantic/dist/components/table.css'
import 'ta-semantic-ui/semantic/dist/components/image.css'
import 'ta-semantic-ui/semantic/dist/components/icon.min.css'

export default class Footer extends Component {

  constructor() {
    super();

    this.state = ({
      showOverlay: true
    })

  }

  render() {

    return (

      <div className='footer-wrapper' key='footer'>



        <div
          className='ui secondary inverted very fitted vertical segment'
          style={{
            maxWidth: 'none',
            background: 'rgba(0,0,0,0.9)'
          }}
        >


          <div className='ui container'>

            <div className='ui two column stackable inverted middle aligned centered vertically divided grid'>

              <div className='row'>
                <div className='column'>
                  <table className='ui very basic inverted table'>
                    <tbody>

                    <tr className='top aligned'>
                      <td scope='row'>Text</td>
                      <td>
                        <div className='ui list'>
                          <div
                            className='item'
                            style={{paddingTop:'2px'}}
                          >Patrice Siegrist <a className='white-blue-link' href='https://twitter.com/pasiegrist' target='_blank'><i className='twitter icon'></i></a></div>
                        </div>
                      </td>
                    </tr>

                    <tr className='top aligned'>
                      <td scope='row'>Programmierung</td>
                      <td>
                        <div className='ui list'>
                          <div
                            className='item'
                            style={{paddingTop:'2px'}}
                          >Marc Fehr <a className='white-blue-link' href='https://twitter.com/mrcfhr' target='_blank'><i className='twitter icon'></i></a></div>
                        </div>
                      </td>
                    </tr>




                    <tr className='top aligned'>
                      <td scope='row'>Fotografien</td>
                      <td>
                        <div className='ui list'>
                          <div
                            className='item'
                            style={{paddingTop:'2px'}}
                          >Sabina Bobst </div>
                        </div>
                      </td>
                    </tr>

                    <tr className='top aligned'>
                      <td scope='row'>Video</td>
                      <td>
                        <div className='ui list'>
                          <div
                            className='item'
                            style={{paddingTop:'2px'}}
                          >Patrice Siegrist <a className='white-blue-link' href='https://twitter.com/pasiegrist' target='_blank'><i className='twitter icon'></i></a></div>
                        </div>
                      </td>
                    </tr>

                    <tr className='top aligned'>
                      <td scope='row'>Datengrundlage</td>
                      <td>
                        <div className='ui list'>
                          <div
                            className='item white-blue-link'
                            style={{paddingTop:'2px'}}
                          ><a style={{color: 'white'}} href='https://www.stadt-zuerich.ch/prd/de/index/statistik.html' target='_blank'>Statistik Stadt Zürich <i className='external icon white-blue-link'></i></a><br/>
                            <a style={{color: 'white'}} href='https://www.wuestpartner.com/' target='_blank'>Wüest Partner <i className='external icon white-blue-link'></i></a><a
                                   style={{color: 'white'}} href='https://data.stadt-zuerich.ch/' target='_blank'><br/>Open Data Zürich <i className='external icon white-blue-link'></i></a></div>
                        </div>

                      </td>
                    </tr>



                    </tbody>
                  </table>



                </div>
              </div>

              { this.state.showOverlay &&

                <div className='row'>
                  <div className='column'>
                    <h3
                      style={{
                        fontFamily: 'Benton Sans Cond',
                        fontWeight: 'bold'
                      }}
                    >
                      <i className='bar chart icon'></i> Weitere Infos zu den Daten
                    </h3>
                    <p>Sofern nicht anders ausgewiesen, wurden die Daten für diesen Artikel von Statistik Stadt Zürich verwendet. Mittel- und Durchschnittswerte beziehen sich auf den Median. Die Steuerdaten gibt Statistik Stadt Zürich nur bis 2014 heraus. Das sind somit die aktuellsten Daten. Selbst für 2014 gibt es noch eine gewisse Unschärfe. Das definitive steuerbare Einkommen liegt erst für 86,7 Prozent der Steuerpflichtigen vor. Die Interpretation der Steuerdaten im Stadtkreis 1 ist schwierig. Dort enthalten sind auch Personen ohne eigene Wohnmeldeadresse, aber mit Wohnsitz in der Stadt Zürich (zum Beispiel Gefängnisinsassen oder Personen in Heimen und Anstalten ausserhalb der Stadt Zürich).
                    </p>
                    <p>Das statistische Quartier <strong>Alt-Wiedikon</strong> wurde aus programmiertechnischen Gründen von uns in Wiedikon umbenannt.
                    </p>
                  </div>
                </div>

              }

              <div className='row' style={{borderTop: 'none'}}>
                <div className='column' style={{border: 'none'}}>
                  <div className='ui icon message'><i className='comments icon'></i>
                    <div className='content' style={{textAlign: 'left', lineHeight: '25px'}}>
                      <div className='header'> Haben Sie Anmerkungen oder einen Fehler entdeckt?</div>
                      <p>Wir freuen uns über Ihre <a className='orange-link' href='mailto:interaktiv@tages-anzeiger.ch'>Nachricht</a>.
                      </p>
                    </div>
                  </div>


                  <div className='ui tertiary inverted vertical center aligned very fitted basic segment'>
                    <img src='//interaktiv.tagesanzeiger.ch/static/icons/logo-ta-icon-inverted.svg' alt='' className='ui mini middle aligned right spaced image' />
                    <small>© 2016 Tages-Anzeiger</small>
                  </div>


                </div>

              </div>
            </div>
          </div>
        </div>

        <div
          className='ui vertical segment ta footer shadowed'
          style={{
            margin: '0 auto',
            marginBottom: '15px',
            paddingTop: '43px'
          }}
        >
          <div className='ui container'>
            <div className='ui one column doubling stackable divided grid'>
              <div className='center aligned column'>
                <div className='ui vertical labeled icon buttons'>
                  <a href={`https://www.facebook.com/sharer/sharer.php?u=${this.props.shareUrl}`} target='_blank' className='white-link ui facebook button fb-share'><i className='facebook icon' target='_blank'>
                  </i>Auf Facebook teilen</a>
                  <a target='_blank' href={`https://twitter.com/intent/tweet?text=${this.props.twitterShareText}`} className='white-link ui twitter button twitter-share'><i className='twitter icon' target='_blank'></i>
                    Auf Twitter teilen</a>                </div>
              </div>

            </div>
          </div>
        </div>

      </div>



    )
  }

}

Footer.propTypes = {
  handler: React.PropTypes.func,
  shareUrl: React.PropTypes.string,
  twitterShareText: React.PropTypes.string,
  handler: React.PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.component.js